import UploadImage from "@components/UploadImage";
import "./index.scss";
import IconSuccess from "./success.svg?react";
import pricingservice from "@apis/pricingservice";
import { CDN_UPLOAD_URL } from "@config";
import { useAppSelector } from "@hooks/redux";
import { IconClose } from "@icons/index";
import { getRegionIcon } from "@utils/format";
import { parseParam } from "@utils/url";
import { NationalFlag } from "@components/NationalFlag";
import { Modal } from "antd";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import accountCodeMap from "./accountCodeMap";

interface OrderResult {
  items: {
    props: {
      option1: string;
      option2: string;
      country: string;
      level: string;
    };
    title: string;
  }[];
}
export default () => {
  const { region: _region, userInfo } = useAppSelector((state) => state.globalReducer);
  const { regionOptions } = useAppSelector((state) => state.configReducer);
  const orderId = parseParam("orderId") || "";
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<"" | "Gas Station" | "Membership">("");
  const [country, setCountry] = useState("");
  const [orderName, setOrderName] = useState("");
  const bizCountry = userInfo.bizCountry;

  useEffect(() => {
    (async () => {
      if (orderId == "default") {
        setOpen(true);
        return;
      }
      if (orderId && regionOptions) {
        try {
          const res = await pricingservice.queryOrder<OrderResult>(orderId);
          if (res && res.items && res.items.length > 0) {
            if (res.items[0].props) {
              setType("Membership");
              const orderLevel = res.items[0].props.option2 || res.items[0].props.level;
              const orderCountry = res.items[0].props.option1 || res.items[0].props.country;
              setOrderName(orderLevel);
              setCountry(orderCountry);
              const regionOption = regionOptions.find((region) => region.name === orderCountry);
              if (regionOption && regionOption.value) {
                setCountry(regionOption.value);
              }
            } else {
              setType("Gas Station");
              setOrderName(res.items[0].title);
            }
            // dispatch(queryMembership({ country: region }));
          }
        } catch (err) {}
        setOpen(true);
      }
    })();
  }, [orderId, regionOptions]);

  let countryUrl = getRegionIcon(regionOptions, country);
  if (country === "Global") countryUrl = `${CDN_UPLOAD_URL}/upload/a4833265.png`;
  if (country === "Southeast Asia") countryUrl = `${CDN_UPLOAD_URL}/upload/67af1e4b.png`;
  if (country === "Ameu") countryUrl = `${CDN_UPLOAD_URL}/upload/807e73e7.png`;
  if (!open) return null;

  const code = (accountCodeMap as any)[bizCountry] || (accountCodeMap as any).default;
  const isDiscord = code === "discord";
  const codeImage = isDiscord ? `e03ad568.png` : code;
  return (
    <Modal
      footer={null}
      className={classNames("Component-ModalOrderResult")}
      closeIcon={<IconClose></IconClose>}
      open={open}
      onCancel={() => setOpen(false)}
    >
      <div className="container">
        <IconSuccess className="icon-success"></IconSuccess>
        {orderId !== "default" && (
          <div className="info">
            <div className="label">
              <Trans>Order ID</Trans> :
            </div>
            <div className="value">#{orderId.slice(0, 6)}</div>
          </div>
        )}
        {type === "Gas Station" && (
          <div className="info">
            <div className="label">
              <Trans>Recharge Plan</Trans> :
            </div>
            <div className="value">
              <Trans>{orderName}</Trans>
            </div>
          </div>
        )}
        {type === "Membership" && (
          <div className="info">
            <div className="label">
              <Trans>Membership</Trans> :
            </div>
            <div className="value">
              <NationalFlag url={countryUrl} className="w-[32px] h-[24px] mr-[10px]"></NationalFlag>
              <span>
                <Trans>{orderName}</Trans>
              </span>
            </div>
          </div>
        )}
        {(type === "Membership" || orderId === "default") && (
          <div className="desc">
            <Trans>Congratulations! You have successfully finished the purchase!</Trans>
          </div>
        )}
        <div className="min-h-[136px] w-full px-[75px] py-[20px] box-border bg-[#F5F6FA] flex gap-3 mt-[20px]">
          <div className=" relative flex flex-col items-center">
            <UploadImage
              className={classNames("w-[104px] h-[104px]", {
                "!w-[72px] !h-[72px]": isDiscord,
              })}
              name={codeImage}
            ></UploadImage>
            {isDiscord && (
              <span
                className="text-[13px] text-kds-accent cursor-pointer underline flex items-center"
                onClick={() => {
                  window.open("https://discord.com/invite/bbFFS86BCA");
                }}
              >
                <Trans>Click to join</Trans>
                {/* <DiscordSvg className="w-4 h-4"></DiscordSvg> */}
              </span>
            )}
          </div>
          <div className="flex flex-col  text-[#8485AB] text-[18px] font-medium">
            <span className="text-[#222]">
              <Trans>Professional customer support</Trans>
            </span>
            <span className="text-[#666] text-[14px] mt-2 leading-5 font-normal">
              <Trans>
                Scan the code and add customer service for usage support and connect with our abundant business
                resources!
              </Trans>
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};
